<template>
  <section
    id="products__information--warranty"
    style="background-image: url(https://blue.firstechllc.com/wp-content/uploads/bottom-water-1.jpg);"
  >
    <div class="container">
      <div class="products__warranty--container row flex-row">
        <div class="reorder-elements-two products__warranty--content">
          <h2>Your Purchase, Protected.</h2>
          <p>Every Aqua Bed Warmer purchase comes with a 30-Day Satisfaction Guarantee and a 2-Year Warranty that protects you from any defects or malfunctioning components. If it doesn't work, we will fix it!</p>
          <p>
            <a
              class="products__warranty--link"
              href="#product-image-main">Choose Your Size today! ></a>
          </p>
        </div>

        <div class="reorder-elements-one products__warranty--image">
          <img
            src="https://blue.firstechllc.com/wp-content/uploads/badge-100.png"
            alt="Aqua bed satisfaction badge"
            width="350"
            height="350"
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
#products__information--warranty {
  color: #fff;

  .container {
    width: 100%;
    padding: 0px;
  }

  h2 {
    color: #fff;
  }

  .products__warranty--container {
    display: flex;
    flex-direction: row;

    @media screen and (max-width: 800px) {
      display: flex;
      flex-direction: column-reverse;
    }
  }

  .products__warranty--link {
    color: inherit;
    font-weight: bold;

    &:hover {
      text-decoration: underline;
    }
  }

  .products__warranty--content {
    width: 50%;
    padding: 60px 75px 60px 90px;

    h2 {
      margin: 0px;
      font-size: 40px;
      font-weight: 500;
    }

    p {
      font-size: 18px;
    }

    @media screen and (max-width: 1200px) {
      padding: 60px 45px 60px;

      p {
        font-size: 17px;
      }
    }

    @media screen and (max-width: 800px) {
      width: 100%;
      max-width: 500px;
      padding: 15px 30px 30px;

      h2 {
        font-size: 28px;
      }

      p {
        font-size: 16px;
        line-height: 1.4em;
      }
    }
  }

  .products__warranty--image {
    margin: auto;
    width: 50%;
    padding: 60px 30px;

    @media screen and (max-width: 800px) {
      width: 100%;
      padding: 30px 30px 0px;
    }

    img {
      margin: 0 auto;
      display: block;

      @media screen and (max-width: 800px) {
        max-width: 80%;
      }
    }
  }

  @media screen and (max-width: 800px) {
    text-align: center;
  }
}
</style>
